module.exports = __webpack_public_path__ + "labioplastika_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_1_before.jpg
// module id = 1068
// module chunks = 0